import { gql } from '@apollo/client/core';

export const skuGroupCardFragment = gql`
  fragment SkuGroupCardFragment on SkuGroupCard {
    adult
    favorite
    feedbackQuantity
    id
    minFullPrice
    minSellPrice
    discountPercent
    offer {
      due
      icon
      text
      textColor
    }
    badges {
      ... on BottomTextBadge {
        backgroundColor
        description
        id
        link
        text
        textColor
      }
    }
    ordersQuantity
    productId
    rating
    title
    inStock
    photos {
      key
      link(trans: PRODUCT_540) {
        high
        low
      }
      previewLink: link(trans: PRODUCT_240) {
        high
        low
      }
    }
  }
`;
